export default __webpack_public_path__ + "static/media/cover-year.ddcec801.png";